<template>
  <div id="app">
    <v-app :style="{background: $vuetify.theme.themes[theme].background}">

      <v-app-bar v-if="isMobile()" app color="grey darken-4" dark>
         <v-btn @click.stop="toggleLeft()" icon>

          <v-icon>mdi-menu</v-icon>
        </v-btn>
       
        <v-spacer></v-spacer>
        <v-btn @click.stop="toggleRight()" icon>
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </v-app-bar>
     
        <LeftSideNavBar :LeftDrawer="leftDrawer" :stay="isMobile()"></LeftSideNavBar>
        <RightSideNavBar :RightDrawer="rightDrawer" :stay="isMobile()"></RightSideNavBar>
      
      <v-main>
        <v-container fluid>
          <router-view />
        </v-container>
      </v-main>
    </v-app>
  </div>
</template>


<script>
  // @ is an alias to /src
  import LeftSideNavBar from '@/shared/LeftSideNavMenu.vue'
  import RightSideNavBar from '@/shared/RightSideNavMenu.vue'

  export default {
    name: 'App',
    components: {
      LeftSideNavBar,
      RightSideNavBar
    },
    computed: {
      theme() {
        return (this.$vuetify.theme.dark) ? 'dark' : 'light'
      }
    },
    data: () => ({
      leftDrawer: null,
      rightDrawer: false
    }),
    methods: {
      toggleLeft(){
        this.leftDrawer = !this.leftDrawer
        if(this.leftDrawer == true){
        this.rightDrawer = false
        }
        console.log(this.leftDrawer , this.rightDrawer);
      },
       toggleRight(){
        this.rightDrawer = !this.rightDrawer
         if(this.rightDrawer == true){
        this.leftDrawer = false
        }
        console.log(this.leftDrawer , this.rightDrawer);
      },
      isMobile() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          return true
        } else {
          return false
        }
      }
    }
  }
</script>


<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

</style>